import { z } from 'zod';

export const CURRENT_SCHEMA_REVISION = '2026-05-03-12-00-00' as const;
export const MIN_SUPPORTED_REVISION = '2026-05-03-12-00-00' as const;

export const BundleFileEntrySchema = z.object({
  path: z.string().min(1),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  bytes: z.number().int().nonnegative(),
});

export const BundleSignatureSchema = z.object({
  algorithm: z.literal('rsa-pss-sha256'),
  signing_key_id: z.string().min(1),
  signature_b64: z.string().min(1),
});

export const ProjectExportManifestSchema = z.object({
  schema_revision: z.string().regex(/^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}$/),
  exported_at_ms: z.number().int().nonnegative(),
  exported_by_uid: z.string().min(1),
  exported_by_email: z.string().min(1),
  source: z.object({
    workspace_id: z.string().min(1),
    workspace_slug: z.string().min(1),
    project_id: z.string().min(1),
    project_name: z.string().min(1),
  }),
  files: z.array(BundleFileEntrySchema),
  signature: BundleSignatureSchema,
});

export type ParsedBundleFileEntry = z.infer<typeof BundleFileEntrySchema>;
export type ParsedBundleSignature = z.infer<typeof BundleSignatureSchema>;
export type ParsedProjectExportManifest = z.infer<typeof ProjectExportManifestSchema>;
